import { LocalStorageConfigKeys } from '@config/app-storage/local-storage.config';

export class ThemeHelper {
  constructor() {}

  /**
   * Lấy theme mode cuối cùng và đồng bộ cho cả SmartAdmin và Taiga UI
   */
  public static getCurrentThemeMode(): string {
    // Kiểm tra theme từ SmartAdmin trước
    const smartAdminTheme = this.getSmartAdmin();
    if (smartAdminTheme) {
      // Nếu theme từ SmartAdmin có, cập nhật Taiga UI theo
      this.setTaigaUITheme(smartAdminTheme);
      return smartAdminTheme;
    }

    // Nếu không có theme từ SmartAdmin, kiểm tra theme từ Taiga UI
    const taigaUITheme = this.getTaigaUI();
    if (taigaUITheme) {
      return taigaUITheme;
    }

    // Nếu không tìm thấy theme từ cả hai, mặc định là "light"
    return 'light';
  }

  /**
   * @return "light" | "default" | "dark"
   */
  public static getSmartAdmin(): string {
    try {
      const s_data = localStorage.getItem(
        LocalStorageConfigKeys.global.layouts.currentThemeMode
      );
      return JSON.parse(s_data ?? '');
    } catch (err) {
      return '';
    }
  }

  /**
   * @return "light" | "dark"
   */
  public static getTaigaUI(): string | null {
    try {
      const s_tuinight = localStorage.getItem('tuiNight');
      const p_tuinight = JSON.parse(s_tuinight ?? '');
      return p_tuinight === true ? 'dark' : 'light';
    } catch (err) {
      return '';
    }
  }

  /**
   * Cập nhật theme cho Taiga UI sao cho đồng bộ với SmartAdmin
   * @param theme "light" | "dark"
   */
  private static setTaigaUITheme(theme: string): void {
    localStorage.setItem('tuiNight', theme === 'dark' ? 'true' : 'false');
    // Cập nhật Taiga UI theme (bằng cách này, bạn có thể đảm bảo Taiga UI đồng bộ với theme của SmartAdmin)
  }
}
